document.addEventListener("DOMContentLoaded", function () {
  const activeDropdowns = document.querySelectorAll(".mobile-dropdown-active");
  activeDropdowns.forEach((dropdown) => {
    const dropdownContent = dropdown.nextElementSibling;
    const icon = dropdown.querySelector("svg");

    if (dropdownContent && !dropdownContent.classList.contains("active")) {
      dropdownContent.classList.add("active");
      if (icon) {
        icon.style.transform = "rotate(180deg)";
      }
    }
  });

  const dropdownItems = document.querySelectorAll(
    ".mobile-dropdown-item-active"
  );
  dropdownItems.forEach((item) => {
    const parentContent = item.closest(".mobile-dropdown-content");
    if (parentContent && !parentContent.classList.contains("active")) {
      parentContent.classList.add("active");

      const parentToggle = parentContent.previousElementSibling;
      if (parentToggle) {
        const icon = parentToggle.querySelector("svg");
        if (icon) {
          icon.style.transform = "rotate(180deg)";
        }
      }
    }
  });

  const header = document.getElementById("main-header");
  const headerShadow = document.getElementById("header-shadow");
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    const header = document.getElementById("main-header");
    const headerShadow = document.getElementById("header-shadow");
    const mobileMenu = document.getElementById("mobile-menu");

    if (currentScroll > 0) {
      headerShadow.style.opacity = "1";
      header.classList.add("backdrop-saturate-150");
    } else {
      headerShadow.style.opacity = "0";
      header.classList.remove("backdrop-saturate-150");
    }

    if (mobileMenu) {
      const mobileMenuContainer = mobileMenu.querySelector(
        ".mobile-menu-container"
      );
      if (mobileMenuContainer) {
        mobileMenuContainer.style.top = header.clientHeight + "px";
        mobileMenuContainer.style.height = `calc(100vh - ${header.clientHeight}px)`;
      }
    }

    if (currentScroll > lastScroll && currentScroll > 100) {
      header.style.transform = "translateY(-100%)";
    } else {
      header.style.transform = "translateY(0)";
    }

    lastScroll = currentScroll;
  });

  const menuButton = document.getElementById("mobile-menu-button");
  const mobileMenu = document.getElementById("mobile-menu");
  const burgerIcon = document.querySelector(".burger-icon");

  menuButton.addEventListener("click", () => {
    const isExpanded = menuButton.getAttribute("aria-expanded") === "true";
    menuButton.setAttribute("aria-expanded", !isExpanded);

    mobileMenu.classList.toggle("active");
    burgerIcon.classList.toggle("active");

    if (!isExpanded) {
      const header = document.getElementById("main-header");
      const mobileMenuContainer = mobileMenu.querySelector(
        ".mobile-menu-container"
      );
      if (mobileMenuContainer && header) {
        mobileMenuContainer.style.top = header.clientHeight + "px";
        mobileMenuContainer.style.height = `calc(100vh - ${header.clientHeight}px)`;
      }
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  });

  const mobileDropdownToggles = document.querySelectorAll(
    ".mobile-dropdown-toggle"
  );

  mobileDropdownToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const dropdownContent = toggle.nextElementSibling;
      const icon = toggle.querySelector("svg");

      const shouldStayOpen =
        toggle.classList.contains("mobile-dropdown-active") ||
        dropdownContent.querySelector(".mobile-dropdown-item-active");

      mobileDropdownToggles.forEach((otherToggle) => {
        if (otherToggle !== toggle) {
          const otherContent = otherToggle.nextElementSibling;
          const otherIcon = otherToggle.querySelector("svg");
          const otherShouldStayOpen =
            otherToggle.classList.contains("mobile-dropdown-active") ||
            otherContent.querySelector(".mobile-dropdown-item-active");
          if (!otherShouldStayOpen) {
            otherContent.classList.remove("active");
            otherIcon.style.transform = "";
          }
        }
      });

      if (!shouldStayOpen) {
        dropdownContent.classList.toggle("active");
        icon.style.transform = dropdownContent.classList.contains("active")
          ? "rotate(180deg)"
          : "";
      } else if (!dropdownContent.classList.contains("active")) {
        dropdownContent.classList.add("active");
        icon.style.transform = "rotate(180deg)";
      }
    });
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 1024) {
      mobileMenu.classList.remove("active");
      burgerIcon.classList.remove("active");
      menuButton.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
  });

  const navLinks = document.querySelectorAll(".nav-link-modern");

  navLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      const indicator = link.querySelector(".nav-indicator");
      indicator.style.transform = "scaleX(1)";
    });

    link.addEventListener("mouseleave", () => {
      const indicator = link.querySelector(".nav-indicator");
      indicator.style.transform = "scaleX(0)";
    });
  });

  const modernButtons = document.querySelectorAll(
    ".btn-modern-primary, .btn-modern-secondary"
  );

  modernButtons.forEach((button) => {
    button.addEventListener("mouseenter", () => {
      button.classList.remove("animate-shimmer");
      void button.offsetWidth;
      button.classList.add("animate-shimmer");
    });

    button.addEventListener("mouseleave", () => {
      button.classList.remove("animate-shimmer");
    });
  });

  const activeIndicators = document.querySelectorAll(".active-indicator");
  activeIndicators.forEach((indicator) => {
    indicator.style.transform = "scaleX(1)";
  });

  window.addEventListener("resize", function () {
    document.body.style.overflowX = "hidden";
  });
  document.body.style.overflowX = "hidden";

  const desktopLanguageButton = document.getElementById(
    "desktop-language-button"
  );
  const mobileLanguageButton = document.getElementById(
    "mobile-language-button"
  );
  const languageModal = document.getElementById("language-modal");
  const languageModalContent = document.getElementById(
    "language-modal-content"
  );
  const closeLanguageModal = document.getElementById("close-language-modal");
  const langOptions = document.querySelectorAll(".lang-option");

  function openLanguageModal() {
    languageModal.style.visibility = "visible";
    languageModal.style.opacity = "1";

    setTimeout(() => {
      languageModalContent.style.opacity = "1";
      languageModalContent.style.transform = "scale(1)";
    }, 50);

    document.body.style.overflow = "hidden";

    if (desktopLanguageButton) {
      desktopLanguageButton.classList.add("lang-button-active");
    }
    if (mobileLanguageButton) {
      mobileLanguageButton.classList.add("lang-button-active");
    }
  }

  function closeLanguageModalFunc() {
    languageModalContent.style.opacity = "0";
    languageModalContent.style.transform = "scale(0.95)";

    setTimeout(() => {
      languageModal.style.visibility = "hidden";
      languageModal.style.opacity = "0";
      document.body.style.overflow = "";

      if (desktopLanguageButton) {
        desktopLanguageButton.classList.remove("lang-button-active");
      }
      if (mobileLanguageButton) {
        mobileLanguageButton.classList.remove("lang-button-active");
      }
    }, 200);
  }

  if (desktopLanguageButton) {
    desktopLanguageButton.addEventListener("click", openLanguageModal);
  }

  if (mobileLanguageButton) {
    mobileLanguageButton.addEventListener("click", openLanguageModal);
  }

  if (closeLanguageModal) {
    closeLanguageModal.addEventListener("click", closeLanguageModalFunc);
  }

  languageModal.addEventListener("click", function (e) {
    if (e.target === languageModal) {
      closeLanguageModalFunc();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && languageModal.style.visibility === "visible") {
      closeLanguageModalFunc();
    }
  });

  langOptions.forEach(function (option) {
    option.addEventListener("click", function (e) {
        const langCode = this.getAttribute('data-lang');
        const langUrl = this.getAttribute('href');
        langOptions.forEach((opt) => opt.classList.remove("selected"));
        option.classList.add("selected");

        e.preventDefault();
        
        setTimeout(() => {
            closeLanguageModalFunc();
            
            window.location.href = langUrl;
        }, 200);
    });
});
});
